import AttributeEditors from "./itemEditor/attributeEditors/PluginSetup.js";
const install = molten => {
  AttributeEditors.install(molten);
};
export { install };
export default {
  install
};